/*
 * @Author: xiejun jun.xie@gtechhdigi.com
 * @Date: 2024-08-05 18:59:45
 * @LastEditors: xiejun jun.xie@gtechhdigi.com
 * @LastEditTime: 2024-09-03 16:35:07
 * @FilePath: /ua-cnbs-mall/src/utils/pdp.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import dayjs from 'dayjs';
import lo from 'lodash';

/**
 * 商品属性转为MAP
 */
export function toMap(attributes) {
  return lo
    .chain(attributes)
    .map(({ attrCode, attrName, attrValue, attributeValues }, index) => {
      const data = attributeValues
        ? [{ valueCode: attributeValues, valueName: attributeValues }]
        : attrValue;
      const { valueName, valueCode } = (data && data[0]) || {};
      return {
        attrCode,
        attrName,
        valueName,
        valueCode,
        index,
        isIntro: lo.includes(attrCode, 'PDP_INTRO')
      };
    })
    .keyBy('attrCode')
    .value();
}

/**
 * 从商品属性中判断是否包含最终到手价
 */
export function getFinalPrice({ attributes = [] } = {}) {
  const mapData = toMap(attributes);
  const finalPrice = Number(mapData.SHOW_ESTIMATED_PRICE?.valueCode);
  return {
    // 最终价
    finalPrice,
    // 是否显示最终价
    isShowFinalPrice:
      finalPrice > 0 &&
      (mapData.SHOW_ESTIMATED_PRICE_START_TIME?.valueCode
        ? dayjs().isAfter(mapData.SHOW_ESTIMATED_PRICE_START_TIME.valueCode)
        : true) &&
      (mapData.SHOW_ESTIMATED_PRICE_END_TIME?.valueCode
        ? dayjs().isBefore(mapData.SHOW_ESTIMATED_PRICE_END_TIME.valueCode)
        : true)
  };
}

/**
 * 从商品属性中判断是否包含内购价
 */
export function getFFsPrice({ attributes = [] } = {}) {
  const mapData = toMap(attributes);
  const ffsPrice = Number(mapData.INTERNAL_PURCHASE_PRICE?.valueCode);
  // const showFFsTag = localStorage.getItem('showFFSPrice') === 'true';
  return {
    // showFFsTag,
    // 最终价
    ffsPrice,
    // 是否显示最终价
    isShowFFSPrice:
      ffsPrice > 0 &&
      (mapData.INTERNAL_PURCHASE_PRICE_START_TIME?.valueCode
        ? dayjs().isAfter(mapData.INTERNAL_PURCHASE_PRICE_START_TIME.valueCode)
        : true) &&
      (mapData.INTERNAL_PURCHASE_PRICE_END_TIME?.valueCode
        ? dayjs().isBefore(mapData.INTERNAL_PURCHASE_PRICE_END_TIME.valueCode)
        : true)
  };
}
